import { useMemo } from 'react';
import { generateFilterQuery, generateOrderByQueryParams, generatePaginationQueryParams } from '../utils';
import { FilterConfig, Filters } from '../../../types';
import { useDebounceValue } from '../../../hooks/useDebounce';

export const useQueryFilters = <T extends Filters>(
    filters: T,
    filterConfig: FilterConfig,
    showDefaultSorting = true
): string => {
    const queryFilters = useMemo(() => {
        const filterQuery = generateFilterQuery(filters, filterConfig);
        const initialQueryParams = generatePaginationQueryParams(filters.pageNumber, filters.pageSize);
        const orderByParams = generateOrderByQueryParams(filters.sorted, showDefaultSorting);
        return `${filterQuery}${orderByParams}&${initialQueryParams}`;
    }, [filters, filterConfig, showDefaultSorting]);

    return useDebounceValue(queryFilters);
};
